// extracted by mini-css-extract-plugin
export default {"iconBtn":"Heading_iconBtn__-BMLJ"};